import React from 'react';

import { PropsWithClassName } from '@/types/index';
import { cn } from '@/utils';

export const ItemStatistics = React.memo(
  ({
    title,
    sourcIcon,
    score,
    name,
    tourney,
    variant,
    className,
  }: PropsWithClassName<{
    title: string;
    sourcIcon: string;
    score: number | string;
    name: string;
    tourney: string;
    variant: 'red' | 'green';
  }>) => {
    return (
      <div className={cn('font-bold', className)}>
        <p className="text-xs mt-3">{title}</p>
        <div className="flex justify-around w-full mt-5">
          <figure className="mr-2">
            <img alt={title} src={sourcIcon} />
          </figure>
          <div className="flex flex-1">
            <div className="flex-1">
              <p
                className={cn('text-xs', {
                  'text-gdt-status-green': variant === 'green',
                  'text-gdt-status-red': variant === 'red',
                })}
              >
                {name}
              </p>
              <span className="text-gdt-gray-4 font-semibold text-2xs">
                {tourney}
              </span>
            </div>
            <p className="text-base text-gdt-gray-2">{score} pts.</p>
          </div>
        </div>
      </div>
    );
  }
);

ItemStatistics.displayName = 'ItemStatistics';
